import api from './api';

const usersService = {
  all({ q, page, items_per_page }) {
    return api.get(`/users?q=${q || ''}&page=${page || 1}&items_per_page=${items_per_page || 15}`);
  },
  save(payload) {
    if (payload.id) {
      return api.put(`/users/${payload.id}`, payload);
    } else {
      return api.post('/users', payload);
    }
  },
  resetPassword(user_id) {
    return api.post('/users/reset_password', {user_id: user_id });
  },
  roleTypes() {
    return api.get('/users/role_types');
  }
};

export default usersService;
